import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        flex: 1,
        boxShadow: theme.shadows[3],
        paddingTop: theme.spacing(10),
        lineHeight: 0,
        display: 'flex',
    },
    container: {
        height: '100%',
        flex: 1,
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            padding: 0
        }
    },
    stepper: {
        padding: theme.spacing(0, 4),
        // Tamanho do StepIcone custom para não quebrar layout
        "& .MuiStepLabel-iconContainer > div": {
            width: 26,
            height: 26
        },
        // Garante que o container do ícone possa receber o pseudo-elemento
        "& .MuiStepLabel-iconContainer": {
            position: "relative",
        },
    },
    gridItem: {
    },
    finalizadoIcon: {
        fill: theme.palette.primary.main,
        width: 75,
        height: 75,
        marginBottom: theme.spacing(1),
    },
    pointer: {
        cursor: 'pointer',
        fontWeight: 600
    }
}))